export function readStoredValue(key) {
  try {
    return window.localStorage.getItem(key);
  } catch (error) {
    console.error(`Unable to read local storage key ${key}`, error);
    return null;
  }
}

export function readStoredJson(key) {
  const entry = readStoredJsonEntry(key);
  return entry && entry.exists ? entry.value : null;
}

export function readStoredJsonEntry(key) {
  let value;
  try {
    value = window.localStorage.getItem(key);
  } catch (error) {
    console.error(`Unable to read local storage key ${key}`, error);
    return null;
  }
  if (value === null) return { exists: false, value: null };
  try {
    return { exists: true, value: JSON.parse(value) };
  } catch (error) {
    console.error(`Unable to parse local storage key ${key}`, error);
    return null;
  }
}

export function writeStoredValue(key, value) {
  try {
    window.localStorage.setItem(key, value);
  } catch (error) {
    console.error(`Unable to write local storage key ${key}`, error);
  }
}

export function writeStoredJson(key, value) {
  try {
    const serialized = JSON.stringify(value);
    if (serialized === undefined) throw new Error('Value could not be serialized');
    writeStoredValue(key, serialized);
  } catch (error) {
    console.error(`Unable to serialize local storage key ${key}`, error);
  }
}

export function removeStoredValue(key) {
  try {
    window.localStorage.removeItem(key);
  } catch (error) {
    console.error(`Unable to remove local storage key ${key}`, error);
  }
}

export function readSessionStoredJsonEntry(key) {
  let value;
  try {
    value = window.sessionStorage.getItem(key);
  } catch (error) {
    console.error(`Unable to read session storage key ${key}`, error);
    return null;
  }
  if (value === null) return { exists: false, value: null };
  try {
    return { exists: true, value: JSON.parse(value) };
  } catch (error) {
    console.error(`Unable to parse session storage key ${key}`, error);
    return null;
  }
}

export function readSessionStoredJson(key) {
  const entry = readSessionStoredJsonEntry(key);
  return entry && entry.exists ? entry.value : null;
}

export function writeSessionStoredJson(key, value) {
  try {
    const serialized = JSON.stringify(value);
    if (serialized === undefined) throw new Error('Value could not be serialized');
    window.sessionStorage.setItem(key, serialized);
  } catch (error) {
    console.error(`Unable to write session storage key ${key}`, error);
  }
}

export function removeSessionStoredValue(key) {
  try {
    window.sessionStorage.removeItem(key);
  } catch (error) {
    console.error(`Unable to remove session storage key ${key}`, error);
  }
}
